import { render, staticRenderFns } from "./ChannelFour.vue?vue&type=template&id=05395e4b&scoped=true"
import script from "./ChannelFour.vue?vue&type=script&lang=js"
export * from "./ChannelFour.vue?vue&type=script&lang=js"
import style0 from "./ChannelFour.vue?vue&type=style&index=0&id=05395e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05395e4b",
  null
  
)

export default component.exports